import Tooltip from '@material-ui/core/Tooltip';
import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import withTranslations from '../../utils/HighOrderComponent';
import ModalForAddMunicipalityToPlace from './ModalForAddMunicipalityToPlace';
import ModalForUpdateMunicipalityName from './ModalForUpdateMunicipalityName';

class MunicipalityRow extends Component {
  constructor() {
    super();
    this.state = {
      showMunicipalityToPlace: false,
      showModalForUpdateName: false,
    };
  }

  handleClose = () => {
    this.setState({
      showMunicipalityToPlace: false,
      showModalForUpdateName: false,
    });
  };

  handleOpen = () => {
    this.setState({ showMunicipalityToPlace: true });
  };

  handleOpenUpdateName = () => {
    this.setState({ showModalForUpdateName: true });
  };

  updateMunicipality = (place) => {
    const { NotificationMessages } = this.props;
    this.props.updateMunicipality(
      place,
      this.handleClose,
      NotificationMessages
    );
  };
  render() {
    const { index, municipality, t, placeList } = this.props || {},
      { name, place } = municipality || {},
      { name: placeName } = place || '',
      { Tooltips } = t || {};

    const row = (
      <tr className="text-center">
        <td>{index}</td>
        <td>{name}</td>
        <td>{placeName}</td>
        <td>
          <Link onClick={this.handleOpen} to="#">
            <Tooltip title={Tooltips.updatePlace} placement="top" arrow={true}>
              <i className="fas fa-pen fa-2x" />
            </Tooltip>
          </Link>
        </td>
        <td>
          <Link onClick={this.handleOpenUpdateName} to="#">
            <Tooltip
              title={Tooltips.updateMunicipality}
              placement="top"
              arrow={true}
            >
              <i className="fas fa-edit fa-2x" />
            </Tooltip>
          </Link>
        </td>
      </tr>
    );

    return (
      <Fragment>
        {row}
        {this.state.showMunicipalityToPlace && (
          <ModalForAddMunicipalityToPlace
            show={this.state.showMunicipalityToPlace}
            handleClose={this.handleClose}
            municipality={municipality}
            updateMunicipality={this.updateMunicipality}
            placeList={placeList}
          />
        )}
        {this.state.showModalForUpdateName && (
          <ModalForUpdateMunicipalityName
            show={this.state.showModalForUpdateName}
            handleClose={this.handleClose}
            municipality={municipality}
            updateMunicipality={this.updateMunicipality}
            signalOfUpdate={true}
            placeList={placeList}
          />
        )}
      </Fragment>
    );
  }
}

export default withTranslations(MunicipalityRow, 'MunicipalityRow');
